import { client } from '../store/index'


// GET QUERIES
async function queries(query: any, variables?: any){

    return await this.query({
        query, variables
    })
}
export const Queries = queries.bind(client)

// SET MUTATIONS
async function mutations(mutation: any, variables:any){

    return await this.mutate({
        mutation, variables
    })
}
export const Mutation = mutations.bind(client)